import {Routes} from '@angular/router';
import {URL_PATH_CONFIGS} from '../configs/url-path.config';
import {hasUnsavedChangesRouteGuard} from './route-guards/has-unsaved-changes-route-guard';
import {isUnsupportedBrowserRouteGuard} from './route-guards/is-unsupported-browser-route-guard';
import {environment} from 'src/environments/environment';

export const APP_ROUTES: Routes = [
    {
        path: URL_PATH_CONFIGS.paths.magnets,
        loadComponent: () => import('./components/file-explorer/file-explorer.component').then(m => m.FileExplorerComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: URL_PATH_CONFIGS.paths.clickFinder,
        loadComponent: () => import('./components/click-finder/click-finder.component').then(m => m.ClickFinderComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: `${URL_PATH_CONFIGS.paths.vaultDetail}/:vaultId/in-progress/document/:checkedOutDocumentId`,
        loadComponent: () => import('./components/previews/in-progress-preview/in-progress-preview.component').then(c => c.InProgressPreviewComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: `${URL_PATH_CONFIGS.paths.vaultDetail}/:vaultId/trash/document/:documentId`,
        loadComponent: () => import('./components/previews/trash-document-preview/trash-document-preview.component').then(c => c.TrashDocumentPreviewComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: `${URL_PATH_CONFIGS.paths.vaultDetail}/:vaultId/admin/group/:groupId`,
        loadComponent: () => import('./components/vault-user-group-admin/vault-user-group-admin.component').then(m => m.VaultUserGroupAdminComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: `${URL_PATH_CONFIGS.paths.vaultDetail}/:vaultId/admin`,
        loadComponent: () => import('./components/vault-admin/vault-admin.component').then(m => m.VaultAdminComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: `${URL_PATH_CONFIGS.paths.vaultDetail}/:vaultId`,
        loadComponent: () => import('./components/vault-detail/vault-detail.component').then(m => m.VaultDetailComponent),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        children: [
            {
                path: '',
                loadComponent: () => import('./components/vault-detail/vault-detail-documents/vault-detail-documents.component').then(m => m.VaultDetailDocumentsComponent),
                canDeactivate: [hasUnsavedChangesRouteGuard],
            },
            {
                path: 'in-progress',
                loadComponent: () => import('./components/vault-detail/vault-detail-in-progress/vault-detail-in-progress.component').then(m => m.VaultDetailInProgressComponent),
                canDeactivate: [hasUnsavedChangesRouteGuard],
            },
            {
                path: 'trash',
                loadComponent: () => import('./components/vault-detail/vault-detail-trash/vault-detail-trash.component').then(m => m.VaultDetailTrashComponent),
                canDeactivate: [hasUnsavedChangesRouteGuard],
            },
        ],
    },
    {
        path: URL_PATH_CONFIGS.paths.search,
        loadComponent: () => import('./components/search/search.component').then(m => m.SearchComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: URL_PATH_CONFIGS.paths.favorites,
        loadComponent: () => import('./components/favorites/favorites.component').then(m => m.FavoritesComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: URL_PATH_CONFIGS.paths.lastEdited,
        loadComponent: () => import('./components/last-edited/last-edited.component').then(m => m.LastEditedComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: URL_PATH_CONFIGS.paths.newestDocuments,
        loadComponent: () => import('./components/newest-documents/newest-documents.component').then(m => m.NewestDocumentsComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: URL_PATH_CONFIGS.paths.searchQuery,
        loadComponent: () => import('./components/search-query/search-query.component').then(m => m.SearchQueryComponent),
        canDeactivate: [hasUnsavedChangesRouteGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    },
    {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./pages/layout-tablet/layout-tablet.routes').then(m => m.TABLET_ROUTES),
    },
    {
        path: 's',
        loadChildren: () => import('./pages/layout-smartphone/layout-smartphone.routes').then(m => m.SMARTPHONE_ROUTES),
    },
    {
        path: URL_PATH_CONFIGS.paths.auth,
        loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES)
    },
    {
        path: 'patterns',
        canActivate: [(): boolean => !environment.production],
        loadComponent: () => import('./components/patterns/patterns.component').then(m => m.PatternsComponent),
    },
    {
        path: 'unsupported-browser',
        canActivate: [isUnsupportedBrowserRouteGuard],
        loadComponent: () => import('./pages/unsupported-browser/unsupported-browser.component').then(m => m.UnsupportedBrowserComponent),
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth/login',
    }
];
